export default "__VITE_ASSET__96720392__"